(function () {
	document.addEventListener('shopify:section:load', function () {
		document.querySelectorAll('.js-media-list, .js-media-sublist').forEach((el) => {
			if (el.swiper) {
				el.swiper.destroy(true, true)
			}
		})

		if (typeof subSliderInit === 'function' && typeof sliderInit === 'function') {
			subSliderInit(true)
			sliderInit(true)
		}
	})
})()
